import React from 'react';
import { Checkbox } from "primereact/checkbox";

import { getBuyerProductSpecification } from "../../../utils";
import { round } from '../../../utils';


const MaterialConfirmDailogModal = (props) => {
    const { raisePOData, materialDetails, materialDeclaration, setMaterialDeclaration } = props
    const { buyerPo, buyerPoItems} = raisePOData

    return(
        <div className="">
            <div className="dispatch-note-list">
                <div className="custom-table-container">
                    <table className="custom-product-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="">
                                <th className="" style={{ width: "5%" }}>SR</th>
                                <th className="" style={{ width: "55%" }}>MATERIAL</th>
                                <th className="" style={{ width: "12%" }}>QUANTITY</th>
                                <th className="" style={{ width: "12%" }}>AMOUNT BEFORE TAX</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                        {
                                buyerPoItems?.map((eachBuyerReqItem, index) => {
                                    let relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachBuyerReqItem?.materialId)
                                    
                                    return (
                                        <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                            <td className="">{index + 1}</td>
                                            <td className="">
                                                <div className="ml-2">
                                                    <span className="text-600 font-semibold">
                                                        {relatedMaterial?.companyProdName ? `${relatedMaterial?.companyProdName} | ` : `${relatedMaterial?.productName} | `}
                                                    </span>
                                                    <span className="text-xs">
                                                        {getBuyerProductSpecification(relatedMaterial?.companyProdSpec, relatedMaterial?.productSpecification, relatedMaterial?.UOM, relatedMaterial?.UOMValue)}
                                                    </span>
                                                </div>
                                            </td>
                                            <td className="">{eachBuyerReqItem?.bPOQty}</td>
                                            <td className="">{round(eachBuyerReqItem?.bPOItemAmountBeforeTax)}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className="mt-2">
                    <div className="flex flex-row justify-content-end">
                        <p className="my-2" style={{fontSize: "0.8rem"}}>Total PO amount:<span className="font-bold ml-1">{round(buyerPo?.bPOTotalAmountBeforeTax)}</span></p>
                    </div>
                </div>
                <div className="flex flex-row">
                    <Checkbox onChange={e => setMaterialDeclaration(e.checked)} checked={materialDeclaration} style={{ textAlign: "center" }} ></Checkbox>
                    <label style={{ marginBottom: "5px", fontSize: "13px", marginLeft: "8px" }} >I've checked above, and it is correct.</label>
                </div>
            </div>
        </div>
    )
}

export default MaterialConfirmDailogModal